import { NewTourEvent } from '@common/types/traclink/new-tour-event';
import { PlusIcon } from '@components/basics/icons/plus';
import { AnimatePresence } from 'framer-motion';
import { rgba } from 'polished';
import React, { FC, useState } from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';
import { TracpageTourForm } from './tracpage-tour-form';

type Props = {
  isLight: boolean;
  onAdd: (tour: Omit<NewTourEvent, 'ownerId'>) => void;
};

export const TracpageNewTour: FC<Props> = ({ isLight, onAdd }) => {
  const [showNewTour, setShowNewTour] = useState(false);

  return (
    <div style={{ marginBottom: 46 }}>
      <AnimatePresence exitBeforeEnter>
        {!showNewTour ? (
          <Trigger onClick={() => setShowNewTour(true)}>
            <span className="label">
              <Translate id="PROFILE.EVENTS.ADD" />
            </span>
            <div className="icon-wrapper">
              <PlusIcon />
            </div>
          </Trigger>
        ) : (
          <TracpageTourForm
            isLight={isLight}
            onCancel={() => setShowNewTour(false)}
            variant="new"
            formProps={{
              onAdd: (tour) => {
                onAdd(tour);
                setShowNewTour(false);
              },
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

// uses theme from @shared-tracpage
const Trigger = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  border: 2px dashed ${({ theme }) => rgba(theme.colors.primary, 0.1)};
  border-radius: 4px;
  min-height: 48px;
  padding: 28px 24px;
  cursor: pointer;

  .label {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 14px;
    font-weight: 700;
  }

  .icon-wrapper {
    background-color: #086ee5;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    & > svg {
      width: 18px;
      height: 18px;
      & > path {
        fill: #fff;
      }
    }
  }
`;
